
// Formats an "HH:mm[:ss]" cutoff into the same 12-hour label used by the cutoff Select
// (e.g. "12:00 AM", "12:00 PM", "1:05 PM"), so the listing matches the form.
function formatCutoffTime(timeString: string) {
    if (!timeString) return ''

    const [hourPart, minutePart] = timeString.split(':')
    const hours = parseInt(hourPart, 10)
    const minutes = parseInt(minutePart, 10)
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return ''

    const hour12 = hours % 12 || 12
    const amPm = hours < 12 ? 'AM' : 'PM'
    return `${hour12}:${minutes.toString().padStart(2, '0')} ${amPm}`
}

export { formatCutoffTime }
